import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Define aquí el link de tu agenda (Calendly u otro)
  const CALENDLY_URL = "https://calendly.com/avconsulting-info/30min?month=2026-03";

  // Helper component for the Rolling Text Effect
  const NavLink = ({ href, text, isExternal = false }) => {
    const content = (
      <>
        {/* Original Text: Slides UP and out */}
        <span className="block transition-transform duration-500 ease-[cubic-bezier(0.76,0,0.24,1)] group-hover:-translate-y-full">
          {text}
        </span>
        
        {/* Duplicate Text: Slides UP from below to replace the original */}
        <span className="block absolute top-0 left-0 transition-transform duration-500 ease-[cubic-bezier(0.76,0,0.24,1)] translate-y-full group-hover:translate-y-0 text-[#254E70]">
          {text}
        </span>
      </>
    );

    const className = "group relative overflow-hidden h-5 lg:h-6 inline-block text-gray-500 font-medium text-sm lg:text-base cursor-pointer";

    if (isExternal) {
      return (
        <a href={href} className={className}>
          {content}
        </a>
      );
    }

    return (
      <Link to={href} className={className}>
        {content}
      </Link>
    );
  };

  return (
    <nav className="max-w-[90rem] mx-auto px-6 md:px-12 py-6 bg-white font-sans">
      <div className="flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center">
          <img src="/logo.png" alt="AV Global" className="h-16 w-auto" />
        </Link>

        {/* Desktop Nav Links with Rolling Effect */}
        <div className="hidden md:flex items-center gap-8">
          <NavLink href="/" text="Inicio" isExternal />
          <NavLink href="/nosotros" text="Nosotros" />
          <NavLink href="/servicios" text="Servicios" isExternal />
          <NavLink href="/contacto" text="Contacto" isExternal />
        </div>

        {/* Desktop Nav Button - Convertido a etiqueta <a> */}
        <a 
          href={CALENDLY_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="hidden md:flex bg-[#1D4D73] hover:bg-[#1a3b5c] text-white px-1 py-1 rounded-full items-center transition-colors text-sm font-medium group"
        >
          <span className='px-4'>Agendar Asesoría Gratuita</span>
          <div className="bg-white rounded-full p-3 text-[#285176] transition-transform duration-300 group-hover:scale-110">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M7 17L17 7" />
              <path d="M7 7h10v10" />
            </svg>
          </div>
        </a>

        {/* Mobile Burger Menu Button */}
        <button 
          className="md:hidden flex flex-col gap-1.5 w-8 h-8 items-center justify-center z-50 relative"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`block w-6 h-0.5 bg-[#254E70] transition-all duration-300 ${isMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
          <span className={`block w-6 h-0.5 bg-[#254E70] transition-all duration-300 ${isMenuOpen ? 'opacity-0' : ''}`}></span>
          <span className={`block w-6 h-0.5 bg-[#254E70] transition-all duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
        </button>
      </div>

      {/* Mobile Menu Dropdown */}
      <div className={`md:hidden overflow-hidden transition-all duration-500 ease-in-out ${isMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}>
        <div className="flex flex-col gap-4 pt-6 pb-4">
          <Link to="/nosotros" className="text-gray-500 hover:text-[#254E70] transition-colors font-medium py-2" onClick={() => setIsMenuOpen(false)}>Nosotros</Link>
          <Link to="/servicios" className="text-gray-500 hover:text-[#254E70] transition-colors font-medium py-2" onClick={() => setIsMenuOpen(false)}>Servicios</Link>
          <Link to="/contacto" className="text-gray-500 hover:text-[#254E70] transition-colors font-medium py-2" onClick={() => setIsMenuOpen(false)}>Contacto</Link>
          
          {/* Mobile Button - Convertido a etiqueta <a> */}
          <a 
            href={CALENDLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#254E70] hover:bg-[#1a3b5c] text-white px-6 py-2.5 rounded-full flex items-center justify-center gap-2 transition-colors text-sm font-medium mt-2 w-full"
            onClick={() => setIsMenuOpen(false)}
          >
            <span>Agendar Asesoría Gratuita</span>
            <div className="bg-white/20 rounded-full p-1">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <path d="M7 17L17 7" />
                <path d="M7 7h10v10" />
              </svg>
            </div>
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;